import type { ProposalType } from '@cdf/api-client-react';
import { Button } from '@/components/ui/button';
import { proposalTypeLabels } from './proposal-presentation';

export function ProposalTypePicker({ value, onChange, disabled = false }: {
  value: ProposalType; onChange: (value: ProposalType) => void; disabled?: boolean;
}) {
  return <fieldset disabled={disabled} className="space-y-2">
    <legend className="text-sm font-medium">Proposal type</legend>
    <div className="flex gap-2" role="group" aria-label="Proposal type">
      {(Object.keys(proposalTypeLabels) as ProposalType[]).map(type =>
        <Button key={type} type="button" variant={value === type ? 'secondary' : 'outline'}
          aria-pressed={value === type} onClick={() => onChange(type)}>{proposalTypeLabels[type]}</Button>)}
    </div>
    <p className="text-xs text-muted-foreground">Confirm this choice when creating the proposal. Its type stays fixed afterward.</p>
  </fieldset>;
}
